module.exports = __webpack_public_path__ + "static/the-memoirs-of-catherine-the-great-457cc8cef4b97c3fb7981026008e8b31.jpg";